import { protagonist } from '../../content/protagonist/protagonist';
import { expToNextLevel } from '../progress/progression';
import type { PlayerState } from './types';

/** Build mutable runtime state from the validated protagonist JSON definition. */
export function createInitialPlayer(): PlayerState {
  return {
    faction: protagonist.faction,
    level: protagonist.level,
    exp: protagonist.exp,
    expToNext: expToNextLevel(protagonist.level),
    statPoints: protagonist.statPoints,
    hp: protagonist.hp,
    maxHp: protagonist.maxHp,
    mana: protagonist.mana,
    maxMana: protagonist.maxMana,
    gold: protagonist.gold,
    stats: { ...protagonist.stats },
    skillIds: [...protagonist.skillIds],
    inventory: protagonist.inventory.map((stack) => ({ ...stack })),
    alive: protagonist.hp > 0,
  };
}
